export default ({ request }) => ({
  /**
     * 获取弹幕
     * @param params
     * @returns {*}
     * @constructor
     */
  api_get_bulletchat (params = {}) {
    // 接口请求
    return request({
      url: '/bulletchat',
      method: 'GET',
      params
    })
  },

  /**
     * 发送弹幕
     * @param data
     * @returns {*}
     * @constructor
     */
   api_send_bulletchat (data = {}) {
    // 接口请求
    return request({
      url: '/bulletchat',
      method: 'POST',
      data
    })
  },

})

